// #region URL_JOIN
// https://github.com/jfromaniello/url-join

import * as juice from "juice";
import config from "./config";
import { ICoords } from "./redux/modules/flightMarkers/flightMarkersReducer";

export function urlJoin(...args: string[]): string {
  const joined = [].slice.call(args, 0).join("/");
  return normalize(joined);
}

export function metersToFeet(meters: number): number {
  return meters * 3.2808399;
}

export function feetToMeters(feet: number): number {
  return feet * 0.3048;
}

export function meterCubicToYardCubic(meters: number) {
  return Number(meters) * 1.308;
}

function normalize(s: string): string {
  let str = s;
  if (startsWith(str, "file://")) {
    // make sure file protocol has max three slashes
    str = str.replace(/(\/{0,3})\/*/g, "$1");
  } else {
    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, "://");
    // remove consecutive slashes
    str = str.replace(/([^:\s%3A])\/+/g, "$1/");
  }
  // remove trailing slash before parameters or hash
  str = str.replace(/\/(\?|&|#[^!])/g, "$1");
  // replace ? in parameters with &
  str = str.replace(/(\?.+)\?/g, "$1&");
  return str;
}

function startsWith(str: string, searchString: string) {
  return str.substr(0, searchString.length) === searchString;
}

// #endregion URL_JOIN

export function formatDateMMMDD(dateStr: string): string {
  const [_year, monthNum, dateNum] = dateStr
    .split("-")
    .map((s: string) => parseInt(s, 10));

  const enDate = (month: number, date: number) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${months[month - 1]} ${date}`;
  };

  const ruDate = (month: number, date: number) => {
    const months = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    return `${date} ${months[month - 1]}`;
  };

  return config.language === "ru"
    ? ruDate(monthNum, dateNum)
    : enDate(monthNum, dateNum);
}

export function formatDateYYYYMMDD(dateStr: string): string {
  const [year, month, date] = dateStr.split("-");
  return `${date}.${month}.${year}`;
}

/* tslint:disable:max-line-length */
export function createEmailHtml(html: string, styles: string) {
  return juice(
    `<!DOCTYPE html><html><head>` +
      `<meta name=”x-apple-disable-message-reformatting”>` +
      `<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&amp;subset=cyrillic-ext" rel="stylesheet">` +
      `<style type="text/css">` +
      styles +
      `</style></head><body style="padding: 0; margin: 0">` +
      html +
      `</body></html>`,
  );
}

export function targetIsDescendant(event: any, parent: any) {
  let node = event.target;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

export const createRandomId = (length: number): string => {
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export const createFlightMarkerId = () => createRandomId(10);

export function msg(en: string, ru?: string): string {
  if (ru && config.language === "ru") {
    return ru;
  } else {
    return en;
  }
}

export function createDateString(dt: Date): string {
  return `${pz(dt.getDate())}/${pz(dt.getMonth() + 1)}/${dt.getFullYear()}`;

  function pz(n: number): string {
    const str = n + "";
    return str.length === 1 ? `0${str}` : str;
  }
}

export const getFormattedDayAndMonth = (date: string): string => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
  });

  return formatter.format(new Date(date));
};

export const areCoordinatesAlmostEqual = (
  c1: ICoords,
  c2: ICoords,
  tolerance = 3,
  ignoreZ = false,
) => {
  const multiplier = Math.pow(10, tolerance);
  return (
    Math.trunc(c1.x * multiplier) === Math.trunc(c2.x * multiplier) &&
    Math.trunc(c1.y * multiplier) === Math.trunc(c2.y * multiplier) &&
    (ignoreZ || Math.trunc(c1.z * multiplier) === Math.trunc(c2.z * multiplier))
  );
};
